import { useMutation } from "@tanstack/react-query";
import { getExportDownloadUrl } from "@/features/exports/api/downloadUrl";
import { formatApiError } from "@/lib/http/error-handler";

export interface ExportDownloadParams {
  jobId: string;
  fileId: number;
}

export function useExportDownload() {
  return useMutation({
    mutationFn: ({ jobId, fileId }: ExportDownloadParams) =>
      getExportDownloadUrl(jobId, fileId),
    onSuccess: (data) => {
      if (data.download_url) {
        window.open(data.download_url, "_blank", "noopener");
      }
    },
  });
}

export function downloadErrorMessage(error: unknown): string {
  return formatApiError(error, "download");
}
